import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@heidi/design-system/tooltip';
import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { lastSourceRequiredMessages } from './last-source-required.messages';

/**
 * Wraps a disabled control so hover can show why the last Evidence source
 * cannot be turned off. Children must not be the TooltipTrigger asChild
 * target themselves when they are a Radix Switch/Checkbox (data-state clash).
 */
export function LastSourceRequiredTooltip({ children }: { children: ReactNode }) {
  const intl = useIntl();
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex shrink-0">{children}</span>
      </TooltipTrigger>
      <TooltipContent side="top">
        {intl.formatMessage(lastSourceRequiredMessages.tooltip)}
      </TooltipContent>
    </Tooltip>
  );
}
